import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'reporte-vigilancia-tareas-barra',
  standalone: false,
  template: `
  <div class="header-mainInfo">
      <h1 class="control-item">Asistencia y tareas / Vigilancia de tareas</h1>
      <span class="spacer"></span>
  </div>`
})

export class ReporteVigilanciaTareasBarraComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
